import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { Clock, Users, HelpCircle, TrendingDown } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const CaseStudyChallenge = () => {
  const { ref, isVisible } = useScrollAnimation();
  const { t, tObject } = useLanguage();
  const p = "caseStudyBgeh.challenge";
  const items = tObject<Array<{ title: string; description: string }>>(`${p}.items`);
  const icons = [Clock, HelpCircle, Users, TrendingDown];
  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-16 md:py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className={cn("mb-12 transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <p className="text-sm font-semibold text-chathero-orange uppercase tracking-wider mb-3">{t(`${p}.badge`)}</p>
            <h2 className="text-2xl md:text-3xl font-bold text-primary mb-4">{t(`${p}.title`)}</h2>
            <p className="text-lg text-muted-foreground max-w-3xl">{t(`${p}.intro`)}</p>
          </div>
          <div ref={ref as React.RefObject<HTMLDivElement>} className="grid md:grid-cols-2 gap-6">
            {items.map((item, index) => { const Icon = icons[index]; return (
              <div key={index} className={cn("bg-background rounded-2xl p-6 border border-border transition-all duration-500", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{ transitionDelay: isVisible ? `${index * 100}ms` : "0ms" }}>
                <div className="w-12 h-12 rounded-xl bg-chathero-orange/10 flex items-center justify-center mb-4"><Icon className="w-6 h-6 text-chathero-orange" /></div>
                <h3 className="text-lg font-bold text-primary mb-2">{item.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{item.description}</p>
              </div>
            ); })}
          </div>
        </div>
      </div>
    </section>
  );
};
export default CaseStudyChallenge;
